
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.173 36.634c-.26 0-.51-.1-.71-.288a.989.989 0 010-1.404l12.398-12.345c.19-.19.44-.29.71-.29.27 0 .52.11.71.29l12.368 12.315a.988.988 0 010 1.404.999.999 0 01-1.41 0L29.571 24.697 17.873 36.346c-.19.189-.45.288-.7.288z"}}),_c('path',{attrs:{"d":"M29.551 52.713c-12.408 0-22.497-10.046-22.497-22.4 0-12.356 10.089-22.401 22.497-22.401s22.497 10.045 22.497 22.4c0 12.355-10.089 22.4-22.497 22.4zm0-42.81c-11.298 0-20.497 9.16-20.497 20.41s9.199 20.409 20.497 20.409 20.497-9.16 20.497-20.41S40.859 9.903 29.55 9.903z"}})])
          )
        }
      }
    